/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import storage from '@/public/storage.js'; // locationStorage key 'searchWords'

var search = {
  state: {
    type: 1,
    // 1为主页资讯搜索 2 为病例搜索
    keyword: '',
    // 搜索内容
    historyList: storage.getStorage('searchWords') || []
  },
  actions: {
    searchWordActions: function searchWordActions(_ref, word) {
      var commit = _ref.commit,
          state = _ref.state;
      commit('SET_KEYWORD', word);
      var list = storage.getStorage('searchWords') || [];
      list.unshift(word);
      list = Array.from(new Set(list));
      list.splice(10);
      commit('SET_HISTORYLIST', list);
      storage.setStorage('searchWords', list);
    },
    searchClearn: function searchClearn(_ref2) {
      var commit = _ref2.commit;
      sessionStorage.removeItem('searchWords');
      commit('CLEARNHISTORY');
    }
  },
  mutations: {
    SET_KEYWORD: function SET_KEYWORD(state, word) {
      state.keyword = word;
    },
    SET_HISTORYLIST: function SET_HISTORYLIST(state, list) {
      state.historyList = list;
    },
    CLEARNHISTORY: function CLEARNHISTORY(state) {
      state.historyList = [];
    }
  }
};
export default search;